import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { TranslocoLoader, TranslocoModule, provideTransloco } from '@jsverse/transloco';

import { provideTranslocoMessageformat } from '@jsverse/transloco-messageformat';

import { environment } from '../environments/environment';
import languageMapJson from './language-map.json';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    return import(`../assets/i18n/${lang}.json`).then((res) => res.default);
  }
}

export const SUPPORTED_LANGUAGE_MAP = languageMapJson as { [key: string]: string };
export const SUPPORTED_LANGUAGE_CODES = Object.keys(SUPPORTED_LANGUAGE_MAP);

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: SUPPORTED_LANGUAGE_CODES,
        defaultLang: 'en',
        reRenderOnLangChange: true,
        prodMode: environment.production,
      },
      loader: TranslocoHttpLoader,
    }),
    provideTranslocoMessageformat(),
  ],
})
export class TranslocoRootModule {}
